/* V19 draft. Uses the documented FPD public API and native cart handling. */
(() => {
  'use strict';
  if (window.mwkDesignReview) return;
  window.mwkDesignReview = true;
  const modalDone = '[data-pos="modal"] .fpd-btn.fpd-done';
  const pickerSelector = 'variant-selects,variant-radios,variant-picker';
  const params = new URLSearchParams(location.search);
  const cartEdit = params.has('li-key');
  const cartEditor = cartEdit && params.get('mwk-cart-editor') === '1';
  if (cartEditor) document.body.classList.add('mwk-cart-editor');
  const acceptLabel = cartEdit ? 'Größe & Ausführung ändern' : 'Design übernehmen';
  const doneLabel = cartEdit ? 'Änderung speichern und zum Warenkorb' : 'In den Warenkorb';
  if (cartEdit) document.body.classList.add('mwk-cart-design-edit');
  const editOptions = params.get('mwk-edit-options') === '1';
  let preview = '', accepted = false, busy = false, autoOpened = false;
  let pendingVariant = null;
  let previewBar = null, previewBarObserver = null, previewInset = -1;
  let editQuantity = params.has('li-key') ? Number(params.get('mwk-quantity')) : 0;
  if (!Number.isSafeInteger(editQuantity) || editQuantity < 1) editQuantity = 0;

  // Keep the cart line's quantity when FPD opens an existing design. The native
  // product page otherwise starts at one, including after a variant refresh.
  document.addEventListener('input', event => {
    if (!editQuantity || !event.target.matches('#MainContent input[name="quantity"]')) return;
    const quantity = Number(event.target.value);
    if (Number.isSafeInteger(quantity) && quantity > 0) editQuantity = quantity;
  });
  document.addEventListener('change', event => {
    if (!editQuantity || !event.target.matches('#MainContent input[name="quantity"]')) return;
    const quantity = Number(event.target.value);
    if (Number.isSafeInteger(quantity) && quantity > 0) editQuantity = quantity;
  });

  const designer = () => window.FPD && window.FPD.instance;
  const picker = () => document.querySelector(pickerSelector);
  const isOpen = () => document.body.classList.contains('fpd-modal-designer-visible');
  const copy = value => JSON.parse(JSON.stringify(value));

  // Cache only this tab's recently rendered previews. FPD remains responsible
  // for uploading the design; the cache bridges its thumbnail generation time.
  const cacheKey = 'mwk-design-previews-v1';
  const pendingKey = 'mwk-pending-preview-v1';
  const beforeKey = 'mwk-preview-cart-keys-v1';
  const readSession = key => { try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (_) { return null; } };
  const writeSession = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {} };
  let accessoryApproved = false;
  function offerAccessories(event) {
    if (cartEdit || accessoryApproved) return;
    const trigger = event.type === 'submit'
      ? event.target.closest('#MainContent product-form form')?.querySelector('.product-form__submit')
      : event.target.closest('.fpd-done,#MainContent .product-form__submit');
    if (!trigger || trigger.closest('#mwk-variant-dialog') || trigger.disabled) return;
    let catalog;
    try { catalog = JSON.parse(document.getElementById('mwk-accessory-catalog').textContent); } catch (_) { return; }
    const id = Number(document.querySelector('#MainContent product-form input[name="id"]')?.value);
    const variant = catalog.mapVariants.find(item => item.id === id);
    if (!variant?.available) return;
    const size = variant.options.join(' ').replace(/\s/g,'');
    const large = /120[x×]80/i.test(size);
    const medium = /90[x×]60/i.test(size);
    const penTip = large
      ? '120 × 80 cm: Mittel und Dick eignen sich für größere Flächen. Dick in Kombination mit einem gleichfarbigen dünnen Stift für kleine Länder und Details verwenden.'
      : medium
      ? '90 × 60 cm: Fein und Dünn eignen sich für kleine Länder und Details; Mittel zusätzlich für größere Flächen.'
      : '60 × 40 cm: Wir empfehlen Fein und Dünn, damit du kleine Länder und Details sauber ausmalen kannst.';
    const fitsSize = item => large || !/^Dick$/i.test(item.title);
    const groups = [{ key:'pens', title:'Stifte zum Ausmalen', action:'Stift hinzufügen', choose:'Stiftfarbe wählen' }];
    if (variant.options.some(option => /keilrahmen/i.test(option))) groups.push({key:'pins',title:'Pins für deinen Keilrahmen',action:'Pins hinzufügen',choose:'Pins wählen'});
    const available = group => catalog[group.key]?.filter(product => product.variants.some(item => item.available && (group.key !== 'pens' || fitsSize(item)))) || [];
    if (!groups.some(group => available(group).length)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    document.documentElement.classList.remove('mwk-cart-saving');
    if (document.getElementById('mwk-accessory-dialog')) return;
    const dialog = document.createElement('dialog');
    dialog.id = 'mwk-accessory-dialog';
    dialog.setAttribute('aria-labelledby','mwk-accessory-title');
    dialog.innerHTML = '<header><h2 id="mwk-accessory-title">Noch passendes Zubehör?</h2><button type="button" aria-label="Zurück zur Gestaltung" autofocus>×</button></header><div class="mwk-accessory-body"><p>Optional: Ergänze deine Karte mit Stiften zum Ausmalen.</p><div class="mwk-accessory-grid"></div><p role="status" aria-live="polite"></p></div><footer><button type="button" class="button">Weiter zum Warenkorb</button></footer>';
    if (groups.length > 1) dialog.querySelector('.mwk-accessory-body > p').textContent = 'Optional: Ergänze deinen Keilrahmen mit Stiften zum Ausmalen und Pins zum Markieren.';
    const grid = dialog.querySelector('.mwk-accessory-grid');
    const status = dialog.querySelector('[role="status"]');
    const next = dialog.querySelector('footer button');
    const close = dialog.querySelector('header button');
    const discover = document.createElement('a');
    discover.className = 'button mwk-accessory-discover';
    discover.href = '/pages/stifte-pins';
    discover.target = '_blank';
    discover.rel = 'noopener';
    discover.textContent = 'Zubehör zur Karte entdecken';
    discover.setAttribute('aria-label','Zubehör zur Karte entdecken – öffnet die Zubehörseite in einem neuen Tab');
    dialog.querySelector('footer').prepend(discover);
    let adding = false;
    const added = new Set();
    const uncertain = new Set();
    const money = cents => new Intl.NumberFormat('de-DE',{style:'currency',currency:catalog.currency || 'EUR'}).format(cents/100);
    function lock(value) {
      adding = value;
      dialog.querySelectorAll('button,select').forEach(control => control.disabled = value);
      if (!value) dialog.querySelectorAll('[data-mwk-accessory-card]').forEach(card => card.dispatchEvent(new Event('mwk-refresh')));
    }
    groups.forEach(group => {
      const products = available(group);
      if (!products.length) return;
      const card = document.createElement('section');
      card.dataset.mwkAccessoryCard = group.key;
      card.innerHTML = '<h3></h3><img alt=""><label></label><select></select><label></label><select></select><p class="mwk-accessory-price"></p><button type="button" class="button"></button>';
      card.querySelector('h3').textContent = group.title;
      const image = card.querySelector('img');
      const labels = card.querySelectorAll('label');
      const selects = card.querySelectorAll('select');
      const productSelect = selects[0], variantSelect = selects[1];
      labels[0].className = 'mwk-accessory-product-label';
      labels[1].className = 'mwk-accessory-variant-label';
      productSelect.className = 'mwk-accessory-product-select';
      variantSelect.className = 'mwk-accessory-variant-select';
      productSelect.id = 'mwk-accessory-' + group.key;
      labels[0].htmlFor = productSelect.id;
      labels[0].textContent = group.choose;
      variantSelect.id = productSelect.id + '-variant';
      labels[1].htmlFor = variantSelect.id;
      labels[1].textContent = 'Ausführung';
      if (group.key === 'pens') {
        const help = document.createElement('button');
        help.type = 'button';
        help.className = 'mwk-pen-help';
        help.textContent = '?';
        help.title = penTip;
        help.setAttribute('aria-label','Welche Stiftstärke passt zu meiner Kartengröße?');
        help.setAttribute('aria-expanded','false');
        const tip = document.createElement('p');
        tip.className = 'mwk-pen-tip';
        tip.id = 'mwk-pen-size-tip';
        tip.textContent = penTip;
        tip.hidden = true;
        help.setAttribute('aria-controls',tip.id);
        help.addEventListener('click',event => {
          event.preventDefault();
          tip.hidden = !tip.hidden;
          help.setAttribute('aria-expanded',String(!tip.hidden));
        });
        labels[1].append(' ',help);
        labels[1].after(tip);
        const recommendation = document.createElement('p');
        recommendation.className = 'mwk-pen-recommendation';
        recommendation.textContent = large ? 'Für 120 × 80 cm: Dick in Kombination mit einem gleichfarbigen dünnen Stift.' : medium ? 'Für 90 × 60 cm: Fein, Dünn oder Mittel.' : 'Für 60 × 40 cm: Fein oder Dünn empfohlen.';
        card.querySelector('h3').after(recommendation);
      }
      productSelect.add(new Option('Bitte auswählen',''));
      products.forEach((product,index) => productSelect.add(new Option(product.title.replace(/^Ausmalstift\s+/,'').replace(/\s+für Weltkarten$/,''),String(index))));
      const button = card.querySelector('button.button');
      let selected = null;
      function refresh() {
        const product = productSelect.value === '' ? null : products[Number(productSelect.value)];
        selected = product?.variants.find(item => String(item.id) === variantSelect.value && item.available) || null;
        card.querySelector('.mwk-accessory-price').textContent = selected ? money(selected.price) : 'Farbe und Ausführung auswählen';
        button.textContent = selected && uncertain.has(selected.id) ? 'Bitte Warenkorb prüfen' : selected && added.has(selected.id) ? 'Hinzugefügt ✓' : group.action;
        button.disabled = adding || !selected || added.has(selected.id) || uncertain.has(selected.id);
      }
      productSelect.addEventListener('change', () => {
        const product = productSelect.value === '' ? null : products[Number(productSelect.value)];
        variantSelect.replaceChildren();
        product?.variants.filter(item => item.available && (group.key !== 'pens' || fitsSize(item))).sort((a,b) => ['Fein','Dünn','Mittel','Dick'].indexOf(a.title) - ['Fein','Dünn','Mittel','Dick'].indexOf(b.title)).forEach(item => {
          const recommended = group.key === 'pens' && (large ? /^(Dünn|Mittel)$/i.test(item.title) : (/^(Fein|Dünn)$/i.test(item.title) || (medium && /^Mittel$/i.test(item.title))));
          const combination = group.key === 'pens' && large && /^Dick$/i.test(item.title);
          variantSelect.add(new Option((item.title === 'Default Title' ? 'Standard' : item.title) + (recommended ? ' · empfohlen' : combination ? ' · mit gleichfarbigem dünnen Stift' : ''),String(item.id)));
        });
        const shown = product || products[0];
        image.src = shown.image;
        image.alt = shown.title;
        variantSelect.hidden = labels[1].hidden = !product || product.variants.length <= 1;
        refresh();
      });
      variantSelect.addEventListener('change',refresh);
      card.addEventListener('mwk-refresh',refresh);
      button.addEventListener('click',async () => {
        if (adding || !selected || added.has(selected.id)) return;
        const choice = selected;
        lock(true);
        button.textContent = 'Wird hinzugefügt …';
        status.textContent = '';
        let beforeQuantity = null;
        try {
          const before = await cartRequest('cart.js');
          beforeQuantity = before.items.filter(item => item.variant_id === choice.id).reduce((sum,item) => sum + item.quantity,0);
          let addError;
          try { await cartRequest('cart/add.js',{items:[{id:choice.id,quantity:1}]}); } catch(error) { addError = error; }
          const after = await cartRequest('cart.js');
          const quantity = after.items.filter(item => item.variant_id === choice.id).reduce((sum,item) => sum + item.quantity,0);
          if (quantity !== beforeQuantity + 1) throw addError || new Error('Das Hinzufügen konnte nicht bestätigt werden.');
          added.add(choice.id);
          status.textContent = group.key === 'pens' ? 'Stift hinzugefügt. Du kannst noch eine weitere Farbe wählen.' : 'Pins hinzugefügt.';
        } catch(error) {
          // Do not blindly repeat an ambiguous add response.
          if (beforeQuantity !== null) uncertain.add(choice.id);
          status.textContent = error.message + ' Bitte prüfe deinen Warenkorb; die Karte kannst du weiterhin hinzufügen.';
        } finally { lock(false); }
      });
      grid.append(card);
      if (group.key === 'pins') productSelect.value = '0';
      productSelect.dispatchEvent(new Event('change'));
    });
    close.addEventListener('click', () => { if (!adding) dialog.close(); });
    dialog.addEventListener('cancel', event => { if (adding) event.preventDefault(); });
    dialog.addEventListener('close', () => { document.body.classList.remove('mwk-accessory-open'); dialog.remove(); trigger.focus(); });
    next.addEventListener('click', () => {
      if (adding) return;
      accessoryApproved = true;
      dialog.close();
      trigger.click();
    });
    document.body.append(dialog);
    document.body.classList.add('mwk-accessory-open');
    dialog.showModal();
  }
  document.addEventListener('click',offerAccessories,true);
  document.addEventListener('submit',offerAccessories,true);
  function rememberPreview() {
    const fpd = designer();
    if (!fpd?.productCreated) return;
    const variantId = Number(document.querySelector('#MainContent product-form input[name="id"]')?.value || params.get('variant'));
    const before = readSession(beforeKey);
    const record = { variantId, oldKey: params.get('li-key'), oldHash: params.get('_fpd-hash'), quantity: editQuantity || Number(document.querySelector('#MainContent input[name="quantity"]')?.value) || 1, before: before?.keys || [], beforeQuantities: before?.quantities || {}, time: Date.now() };
    writeSession(pendingKey,record);
    capture(fpd).then(data => writeSession(pendingKey, { ...record, data })).catch(() => {});
  }
  document.addEventListener('click', event => {
    // A deliberate designer close returns to the surface where editing began.
    // Let FPD close normally first; closing the size dialog stays in the designer.
    if (cartEdit && !cartEditor && event.isTrusted && event.target.closest('[data-pos="modal"] .fpd-close:not(.fpd-done)')) {
      setTimeout(() => { if (!isOpen()) location.assign('/cart'); }, 0);
    }
    const submit = event.target.closest('#MainContent .product-form__submit');
    if (submit?.closest('#mwk-variant-dialog')?.open && !cartEditor) {
      event.preventDefault();
      event.stopImmediatePropagation();
      document.getElementById('mwk-variant-dialog').close('designer');
      return;
    }
    if (event.target.closest('.fpd-done') || submit) rememberPreview();
    const edit = event.target.closest('a.fpd-edit-button');
    if (edit?.closest('.cart-item')) {
      const rows = Array.from(document.querySelectorAll('.cart-item[data-mwk-key]'));
      writeSession(beforeKey, { keys: rows.map(row => row.dataset.mwkKey), quantities: Object.fromEntries(rows.map(row => [row.dataset.mwkKey,Number(row.querySelector('input[name="updates[]"]')?.value)])) });
    }
  }, true);

  function pendingRows(rows,pending) {
    return rows.filter(row => row.dataset.mwkKey !== pending.oldKey && Number(row.dataset.mwkKey.split(':')[0]) === pending.variantId && row.dataset.mwkHash && (!pending.before.includes(row.dataset.mwkKey) || Number(row.querySelector('input[name="updates[]"]')?.value) === (pending.beforeQuantities?.[row.dataset.mwkKey] || 0) + pending.quantity));
  }

  const previewJobs = new WeakMap();
  function syncCartPreviews() {
    const rows = Array.from(document.querySelectorAll('#main-cart-items .cart-item[data-mwk-hash]')).filter(row => row.dataset.mwkHash);
    if (!rows.length) return;
    let cache = readSession(cacheKey) || {};
    const pending = readSession(pendingKey);
    if (pending?.data && Date.now() - pending.time < 10 * 60 * 1000) {
      const originalStillPresent = rows.some(row => row.dataset.mwkKey === pending.oldKey);
      const candidates = pendingRows(rows,pending);
      if (candidates.length === 1) {
        cache[candidates[0].dataset.mwkHash] = { data: pending.data, time: Date.now() };
        cache = Object.fromEntries(Object.entries(cache).sort((a,b) => b[1].time - a[1].time).slice(0,6));
        writeSession(cacheKey, cache);
        if (!originalStillPresent) writeSession(pendingKey, null);
      }
    }
    rows.forEach(row => {
      const img = row.querySelector('img[data-mwk-personal-preview]');
      if (!img) return;
      const hash = row.dataset.mwkHash;
      let job = previewJobs.get(img);
      if (!job || job.hash !== hash) {
        job = { hash, attempt: 0, loaded: false, cached: cache[hash]?.data };
        previewJobs.set(img, job);
        const url = 'https://fpd-api.ganymede-apps.net/api/fe/line_item_cache/thumbnail_image?data_hash=' + encodeURIComponent(hash);
        const request = () => {
          const probe = new Image();
          probe.onload = () => {
            if (!img.isConnected || previewJobs.get(img) !== job) return;
            job.loaded = true;
            img.removeAttribute('data-mwk-cached-preview');
            img.removeAttribute('data-mwk-preview-error');
            img.srcset = probe.src;
            img.src = probe.src;
            img.classList.add('mwk-preview-ready');
          };
          probe.onerror = () => {
            if (!img.isConnected || previewJobs.get(img) !== job) return;
            if (++job.attempt < 4) setTimeout(request, [1000,3000,8000][job.attempt-1]);
            else if (!job.cached) img.setAttribute('data-mwk-preview-error','');
          };
          probe.src = url + (job.attempt ? '&mwk_retry=' + Date.now() : '');
        };
        request();
      }
      if (job.cached && !job.loaded && img.src !== job.cached) {
        img.setAttribute('data-mwk-cached-preview','');
        img.srcset = job.cached;
        img.src = job.cached;
        img.classList.add('mwk-preview-ready');
        img.removeAttribute('data-mwk-preview-error');
      }
    });
  }

  async function cartRequest(path, body) {
    const response = await fetch((window.Shopify?.routes?.root || '/') + path, {
      method: body ? 'POST' : 'GET', headers: body ? { 'Content-Type': 'application/json' } : {},
      ...(body ? { body: JSON.stringify(body) } : {}), cache: 'no-store'
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Bitte versuche es erneut.');
    return data;
  }
  const sameProperties = (a,b) => JSON.stringify(Object.entries(a || {}).sort()) === JSON.stringify(Object.entries(b || {}).sort());
  async function replaceCartVariant(key, variantId) {
    const before = await cartRequest('cart.js');
    const original = before.items.find(item => item.key === key);
    if (!original) throw new Error('Der Warenkorb wurde inzwischen geändert. Bitte lade ihn neu.');
    if (original.variant_id === variantId) return;
    const properties = { ...original.properties };
    if ('_fpd-variant-id' in properties) properties['_fpd-variant-id'] = String(variantId);
    const target = before.items.find(item => item.variant_id === variantId && sameProperties(item.properties, properties));
    const priorQuantity = target?.quantity || 0;
    const item = { id: variantId, quantity: original.quantity, properties };
    if (original.selling_plan_allocation) item.selling_plan = original.selling_plan_allocation.selling_plan.id;
    // Add first so a failed or unavailable variant never deletes the design.
    // An ambiguous network response is verified; it is never blindly retried.
    let addError;
    try { await cartRequest('cart/add.js', { items: [item] }); } catch (error) { addError = error; }
    let current = await cartRequest('cart.js');
    const added = current.items.find(line => line.variant_id === variantId && sameProperties(line.properties, properties));
    if (!added || added.quantity !== priorQuantity + original.quantity) throw addError || new Error('Die Änderung konnte nicht bestätigt werden. Bitte prüfe deinen Warenkorb.');
    const source = current.items.find(line => line.key === key);
    if (!source || source.quantity !== original.quantity) throw new Error('Der Warenkorb wurde während des Speicherns geändert. Bitte prüfe die Positionen.');
    try { await cartRequest('cart/change.js', { id: key, quantity: 0 }); }
    catch (error) {
      current = await cartRequest('cart.js');
      if (!current.items.some(line => line.key === key)) return;
      const restore = current.items.find(line => line.key === added.key);
      if (restore?.quantity === added.quantity) await cartRequest('cart/change.js', { id: added.key, quantity: priorQuantity });
      throw error;
    }
  }

  // Some FPD variant refreshes lose their original edit key and add the saved
  // design as a second line. Reconcile only a verified new line from this edit,
  // never an unrelated design or an unchanged original after cancellation.
  let reconcilingEdit = false;
  async function finishCartDesignEdit() {
    if (reconcilingEdit || !document.getElementById('main-cart-items')) return;
    const pending = readSession(pendingKey);
    if (!pending?.oldKey || Date.now()-pending.time > 10*60*1000) return;
    const rows = Array.from(document.querySelectorAll('.cart-item[data-mwk-key]'));
    const oldRow = rows.find(row => row.dataset.mwkKey === pending.oldKey);
    if (!oldRow) return;
    const candidates = pendingRows(rows,pending);
    if (candidates.length !== 1) return;
    reconcilingEdit = true;
    const main = document.getElementById('MainContent');
    main.inert = true;
    document.body.classList.add('mwk-cart-reconciling');
    let refreshing = false;
    try {
      const cart = await cartRequest('cart.js');
      const original = cart.items.find(item => item.key === pending.oldKey);
      const saved = cart.items.find(item => item.key === candidates[0].dataset.mwkKey);
      if (!original || !saved || original.quantity !== pending.quantity || saved.quantity !== (pending.beforeQuantities?.[saved.key] || 0) + pending.quantity || original.properties?.['_fpd-hash'] !== pending.oldHash || saved.variant_id !== pending.variantId) return;
      await cartRequest('cart/change.js',{id:original.key,quantity:0});
      refreshing = true;
      location.reload();
    } catch (_) {
      const message = document.createElement('p');
      message.setAttribute('role','alert');
      message.textContent = 'Bitte prüfe deinen Warenkorb: Die bisherige Position konnte noch nicht ersetzt werden.';
      candidates[0].querySelector('.cart-item__details')?.append(message);
    } finally {
      if (!refreshing) { main.inert = false; document.body.classList.remove('mwk-cart-reconciling'); }
    }
  }

  function openCartPreview(trigger) {
    const row = trigger.closest('.cart-item');
    const source = row?.querySelector('.cart-item__image');
    if (!source) return;
    document.getElementById('mwk-cart-preview-dialog')?.remove();
    const dialog = document.createElement('dialog');
    dialog.id = 'mwk-cart-preview-dialog';
    dialog.setAttribute('aria-labelledby','mwk-cart-preview-title');
    dialog.innerHTML = '<header><h2 id="mwk-cart-preview-title">Deine Weltkarte</h2><button type="button" aria-label="Bildvorschau schließen" autofocus>×</button></header><div class="mwk-cart-preview-image"><img><p role="status" aria-live="polite">Vorschau wird geladen …</p><small class="mwk-cart-preview-note">Reduzierte Vorschau – dein Druck erfolgt in hoher Auflösung.</small></div><footer><button type="button" class="button button--secondary" data-mwk-preview-options>Größe & Darstellung ändern</button><button type="button" class="button" data-mwk-preview-edit>Design bearbeiten</button></footer>';
    if (!row.dataset.mwkHash) dialog.querySelector('h2').textContent = row.querySelector('.cart-item__name')?.textContent || 'Produktbild';
    const image = dialog.querySelector('img');
    const status = dialog.querySelector('[role="status"]');
    image.alt = row.dataset.mwkHash ? 'Deine persönliche Weltkarte in großer Ansicht' : source.alt;
    image.hidden = true;
    image.addEventListener('load', () => { image.hidden = false; status.hidden = true; });
    image.addEventListener('error', () => { status.textContent = 'Die Vorschau ist noch nicht verfügbar. Bitte schließe das Fenster und öffne es erneut.'; });
    image.src = source.currentSrc || source.src;
    dialog.querySelector('header button').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      document.body.classList.remove('mwk-cart-preview-open');
      trigger.focus();
      dialog.remove();
    });
    const edit = row.querySelector('a.fpd-edit-button');
    const options = row.querySelector('.mwk-edit-options');
    dialog.querySelector('.mwk-cart-preview-note').hidden = !row.dataset.mwkHash && !options;
    const editButton = dialog.querySelector('[data-mwk-preview-edit]');
    const optionsButton = dialog.querySelector('[data-mwk-preview-options]');
    editButton.hidden = !edit;
    optionsButton.hidden = !options;
    editButton.addEventListener('click', () => { dialog.close(); edit?.click(); });
    optionsButton.addEventListener('click', () => { dialog.close(); if (options) openCartVariantDialog(options,trigger); });
    dialog.querySelector('footer').hidden = !edit && !options;
    document.body.append(dialog);
    document.body.classList.add('mwk-cart-preview-open');
    dialog.showModal();
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('#main-cart-items .mwk-cart-preview-trigger');
    if (!trigger) return;
    event.preventDefault();
    openCartPreview(trigger);
  });

  function openCartVariantDialog(link,returnPreviewTrigger) {
    const row = link.closest('.cart-item');
    let config;
    try { config = JSON.parse(row.querySelector('[data-mwk-cart-options]').textContent); } catch (_) { return; }
    document.getElementById('mwk-cart-variant-dialog')?.remove();
    const dialog = document.createElement('dialog');
    dialog.id = 'mwk-cart-variant-dialog';
    dialog.setAttribute('aria-labelledby','mwk-cart-variant-title');
    dialog.innerHTML = '<header><h2 id="mwk-cart-variant-title">Größe & Darstellung ändern</h2><button type="button" aria-label="Zurück zum Warenkorb">×</button></header><form><div class="mwk-cart-variant-preview"><img alt="Deine persönliche Weltkarte"><p>Deine Gestaltung bleibt erhalten.</p></div><div data-mwk-fields></div><p class="mwk-cart-variant-price"></p><p role="status" aria-live="polite"></p><button type="submit" class="button mwk-save-variant"><span class="mwk-save-spinner" hidden></span><span>Änderung speichern und zum Warenkorb</span></button></form>';
    let saving = false;
    if (returnPreviewTrigger) dialog.querySelector('header button').setAttribute('aria-label','Zurück zur Bildvorschau');
    dialog.querySelector('header button').addEventListener('click', () => { if (!saving) dialog.close(); });
    dialog.addEventListener('cancel', event => { if (saving) event.preventDefault(); });
    dialog.addEventListener('close', () => {
      document.body.classList.remove('mwk-cart-variant-open');
      dialog.remove();
      if (!saving && returnPreviewTrigger?.isConnected) openCartPreview(returnPreviewTrigger);
      else link.focus();
    });
    const current = config.variants.find(variant => variant.id === config.variantId);
    if (!current) return;
    const fields = dialog.querySelector('[data-mwk-fields]');
    const selections = current.options.slice();
    config.options.forEach((name,index) => {
      const label = document.createElement('label');
      label.textContent = name;
      const select = document.createElement('select');
      select.name = 'option-' + index;
      Array.from(new Set(config.variants.map(variant => variant.options[index]))).forEach(value => select.add(new Option(value,value)));
      select.value = selections[index];
      label.append(select);
      fields.append(label);
      select.addEventListener('change', () => { selections[index] = select.value; update(); });
    });
    const save = dialog.querySelector('[type="submit"]');
    const notice = dialog.querySelector('[role="status"]');
    const money = cents => new Intl.NumberFormat('de-DE',{style:'currency',currency:config.currency || 'EUR'}).format(cents/100);
    function update() {
      const variant = config.variants.find(v => v.options.every((value,index) => value === selections[index]));
      save.disabled = !variant?.available;
      dialog.querySelector('.mwk-cart-variant-price').textContent = variant ? money(variant.price) + ' pro Karte' : '';
      notice.textContent = variant?.available ? '' : 'Diese Kombination ist nicht verfügbar. Bitte wähle eine andere Größe oder Darstellung.';
    }
    const image = row.querySelector('img[data-mwk-personal-preview]');
    const modalImage = dialog.querySelector('img');
    modalImage.src = image?.currentSrc || image?.src || '';
    modalImage.hidden = !modalImage.src;
    dialog.querySelector('form').addEventListener('submit', async event => {
      event.preventDefault();
      if (saving || save.disabled) return;
      const variant = config.variants.find(v => v.options.every((value,index) => value === selections[index]));
      if (!variant?.available) return;
      saving = true;
      save.disabled = true;
      dialog.querySelectorAll('select,header button').forEach(el => el.disabled = true);
      dialog.querySelector('.mwk-save-spinner').hidden = false;
      notice.textContent = 'Deine Änderung wird gespeichert …';
      try {
        await replaceCartVariant(config.key,variant.id);
        location.reload();
      } catch (error) {
        saving = false;
        dialog.querySelectorAll('select,header button').forEach(el => el.disabled = false);
        dialog.querySelector('.mwk-save-spinner').hidden = true;
        update();
        notice.textContent = error.message || 'Bitte prüfe deinen Warenkorb und versuche es erneut.';
      }
    });
    update();
    document.body.append(dialog);
    document.body.classList.add('mwk-cart-variant-open');
    dialog.showModal();
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('.mwk-edit-options');
    if (!link?.closest('#main-cart-items') || !link.closest('.cart-item')?.querySelector('[data-mwk-cart-options]')) return;
    event.preventDefault();
    openCartVariantDialog(link);
  });

  function variantDialog() {
    const info = document.querySelector('#MainContent [id^="ProductInfo-"]');
    if (!info || !picker()) return;
    let dialog = document.getElementById('mwk-variant-dialog');
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.id = 'mwk-variant-dialog';
      dialog.setAttribute('aria-labelledby','mwk-variant-title');
      dialog.innerHTML = '<header><h2 id="mwk-variant-title">Größe & Darstellung ändern</h2><button type="button" aria-label="Zurück zum Designer">×</button></header>';
      if (cartEditor) dialog.querySelector('button').setAttribute('aria-label','Abbrechen und zum Warenkorb');
      dialog.querySelector('button').addEventListener('click', () => dialog.close('designer'));
      dialog.addEventListener('cancel', event => { event.preventDefault(); dialog.close('designer'); });
      dialog.addEventListener('close', () => {
        if (cartEditor) { location.assign('/cart'); return; }
        if (dialog.returnValue === 'designer' && !isOpen()) document.getElementById('fpd-customize-button')?.click();
      });
      info.append(dialog);
    }
    // Keep the actual variant controls inside their native ProductInfo section.
    // Shopify and FPD still handle price, variant refresh and cart replacement.
    [panel(),picker(),info.querySelector('[id^="price-"]'),info.querySelector('product-form')].filter(Boolean).forEach(el => dialog.append(el));
    if (!dialog.open) dialog.showModal();
  }

  // Only interrupt an explicit reopen. FPD's automatic cart-edit opening and
  // the continue button keep using the native, saved design path.
  document.addEventListener('click', event => {
    const open = event.target.closest('#fpd-customize-button');
    if (!cartEdit || cartEditor || !open || !event.isTrusted || isOpen()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    let choice = document.getElementById('mwk-design-choice');
    if (!choice) {
      choice = document.createElement('dialog');
      choice.id = 'mwk-design-choice';
      choice.setAttribute('aria-labelledby', 'mwk-design-choice-title');
      choice.innerHTML = '<h2 id="mwk-design-choice-title">Wie möchtest du gestalten?</h2><p>Bearbeite deine gespeicherte Karte weiter oder starte eine neue Gestaltung. Bei einer neuen Gestaltung bleibt der bisherige Artikel im Warenkorb erhalten.</p><button type="button" class="button" data-mwk-continue>Gespeichertes Design weiterbearbeiten</button><a class="button button--secondary" data-mwk-new>Neues Design erstellen</a><button type="button" class="mwk-choice-cancel">Abbrechen</button>';
      choice.querySelector('[data-mwk-continue]').addEventListener('click', () => { choice.close(); document.getElementById('fpd-customize-button')?.click(); });
      choice.querySelector('.mwk-choice-cancel').addEventListener('click', () => choice.close());
      document.body.append(choice);
    }
    const fresh = new URL(location.href);
    ['_fpd-hash', 'li-key', 'mwk-quantity', 'mwk-edit-options'].forEach(key => fresh.searchParams.delete(key));
    const variant = document.querySelector('#MainContent product-form input[name="id"]')?.value;
    if (variant) fresh.searchParams.set('variant', variant);
    if (document.getElementById('mwk-assistant-config')) {
      fresh.searchParams.set('mwk-assistant','1');
      fresh.searchParams.set('mwk-new-design','1');
      fresh.searchParams.delete('mwk-cart-editor');
      ['mwk-draft','mwk-pending','mwk-saved','mwk-account-callback'].forEach(key => fresh.searchParams.delete(key));
    }
    choice.querySelector('[data-mwk-new]').href = fresh.href;
    choice.showModal();
  }, true);

  // Shopify's draft bar is a top-layer popover. It covers the mobile tools
  // regardless of their z-index, so leave its actual collapsed height free.
  function syncPreviewSpace() {
    const wrapper = document.getElementById('PBarNextFrameWrapper');
    if (wrapper !== previewBar) {
      previewBarObserver?.disconnect();
      previewBar = wrapper;
      if (wrapper) {
        previewBarObserver = new ResizeObserver(syncPreviewSpace);
        previewBarObserver.observe(wrapper);
      }
    }
    const inset = wrapper ? Math.min(96, Math.ceil(wrapper.getBoundingClientRect().height)) : 0;
    if (inset === previewInset) return;
    previewInset = inset;
    document.body.style.setProperty('--mwk-preview-inset', inset + 'px');
    // Let FPD recalculate the canvas for the remaining space without reloading
    // or replacing any customer design elements.
    requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
  }

  function panel() {
    let el = document.getElementById('mwk-design-review');
    const selection = picker();
    if (!selection) return null;
    if (!el) {
      el = document.createElement('section');
      el.id = 'mwk-design-review';
      el.setAttribute('aria-label', 'Deine Gestaltung');
      el.innerHTML = '<h2>Deine Gestaltung</h2><img alt="Vorschau deiner persönlichen Weltkarte" hidden><p role="status" aria-live="polite"></p><button type="button" class="button button--secondary">Design weiter bearbeiten</button>';
      el.querySelector('button').addEventListener('click', () => {
        const dialog = document.getElementById('mwk-variant-dialog');
        if (dialog?.open) { dialog.close('designer'); return; }
        const open = document.getElementById('fpd-customize-button');
        if (open) open.click();
      });
      selection.before(el);
    }
    el.hidden = !accepted;
    if (preview) {
      const img = el.querySelector('img');
      if (img.src !== preview) img.src = preview;
      img.hidden = false;
    }
    return el;
  }

  function status(text) {
    const el = panel();
    if (el) el.querySelector('[role="status"]').textContent = text;
  }

  function capture(fpd) {
    return new Promise((resolve, reject) => {
      const timeout = setTimeout(() => reject(new Error('preview timeout')), 20000);
      try {
        fpd.getProductDataURL(url => {
          clearTimeout(timeout);
          if (typeof url === 'string' && url.startsWith('data:image/')) resolve(url);
          else reject(new Error('preview unavailable'));
        });
      } catch (error) { clearTimeout(timeout); reject(error); }
    });
  }

  async function acceptDesign() {
    if (busy) return;
    const fpd = designer();
    const close = document.querySelector('[data-pos="modal"] .fpd-btn.fpd-close:not(.fpd-done)');
    const button = document.getElementById('mwk-accept-design');
    if (!fpd || !fpd.productCreated || !close) return;
    busy = true;
    if (button) { button.disabled = true; button.textContent = 'Vorschau wird erstellt …'; }
    try {
      fpd.deselectElement();
      if (typeof fpd.ensureUsedFonts === 'function') await fpd.ensureUsedFonts();
      preview = await capture(fpd);
      accepted = true;
      document.body.classList.add('mwk-design-accepted');
      // Native close preserves the designer. Never trigger .fpd-done here:
      // that is the existing add-to-cart path and its loading overlay.
      status('Deine Gestaltung bleibt erhalten.');
      variantDialog();
      if (cartEditor) close.click();
      if (cartEditor) panel()?.scrollIntoView({ block: 'start' });
    } catch (_) {
      if (button) button.textContent = 'Vorschau erneut versuchen';
      return;
    } finally {
      busy = false;
      if (button) button.disabled = false;
    }
    if (button) button.textContent = acceptLabel;
  }

  // Keep FPD's own panel-close path, including its internal module state.
  function closeMobileDesignerPanel(root) {
    if (!root?.matches('.fpd-layout-small.fpd-module-visible')) return;
    designer()?.deselectElement();
    root.querySelector('fpd-main-bar > .fpd-close')?.click();
  }

  function syncDesignerPanelClose() {
    const close = document.querySelector('#fpd fpd-main-bar > .fpd-close');
    if (!close || close.dataset.mwkPanelClose) return;
    close.dataset.mwkPanelClose = '1';
    close.setAttribute('role', 'button');
    close.setAttribute('tabindex', '0');
    close.setAttribute('aria-label', 'Zurück zur Weltkarte');
    close.setAttribute('title', 'Zurück zur Weltkarte');
    close.addEventListener('keydown', event => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      closeMobileDesignerPanel(close.closest('#fpd'));
    });
  }

  // Native palette handling applies the color first. Close only the mobile
  // layers panel on the following frame so the updated map is visible.
  document.addEventListener('click', event => {
    const swatch = event.target.closest('#fpd fpd-module-manage-layers .fpd-color-palette [data-hex]');
    if (!swatch) return;
    const root = swatch.closest('#fpd');
    requestAnimationFrame(() => closeMobileDesignerPanel(root));
  }, true);

  function addControls() {
    syncDesignerPanelClose();
    syncPreviewSpace();
    syncCartPreviews();
    finishCartDesignEdit();
    const quantityInput = document.querySelector('#MainContent input[name="quantity"]');
    if (editQuantity && quantityInput && quantityInput.value !== String(editQuantity)) {
      quantityInput.value = String(editQuantity);
    }
    const done = document.querySelector(modalDone);
    const doneText = done?.querySelector('.fpd-label');
    if (doneText && doneText.textContent !== doneLabel) doneText.textContent = doneLabel;
    document.querySelectorAll('#MainContent product-form button[id^="ProductSubmitButton-"] > span:not(.fpd-waiting)').forEach(label => {
      const submit = label.closest('button');
      if (submit?.matches('.loading,[aria-busy="true"]') || label.matches('[class*="loading"],[class*="spinner"]') || label.querySelector('.fpd-loading,.spinner,svg')) return;
      if (cartEdit || label.closest('#mwk-variant-dialog') || /^In den Warenkorb/.test(label.textContent.trim())) {
        const submitLabel = label.closest('#mwk-variant-dialog') ? (cartEditor ? doneLabel : 'Auswahl übernehmen und zum Designer') : 'In den Warenkorb';
        if (label.textContent !== submitLabel) label.textContent = submitLabel;
      }
    });
    if (done) document.querySelectorAll('.fpd-modal-content p').forEach(paragraph => {
      if (paragraph.textContent === 'Wähle Größe und Ausführung auf der Produktseite, bevor du den Designer öffnest.') {
        paragraph.textContent = 'Gestalte zuerst deine Karte. Über „Design übernehmen“ kommst du zurück zur Vorschau und kannst Größe und Ausführung ändern.';
      }
      if (paragraph.textContent.startsWith('4.')) {
        const instructions = cartEdit
          ? '<strong>4. Änderung speichern und zum Warenkorb</strong><br>Mit diesem Button aktualisierst du den vorhandenen Artikel und kehrst zum Warenkorb zurück. Über „Größe & Ausführung ändern“ kannst du vorher die Variante anpassen. Auf der Produktseite aktualisiert „In den Warenkorb“ ebenfalls den vorhandenen Artikel.'
          : '<strong>4. Gestaltung übernehmen oder in den Warenkorb</strong><br>Mit „Design übernehmen“ prüfst du deine Vorschau und wählst Größe und Ausführung. Mit „In den Warenkorb“ übernimmst du die Karte direkt in der gewählten Variante. Im Warenkorb kannst du Design, Größe und Ausführung erneut bearbeiten.';
        if (paragraph.innerHTML !== instructions) paragraph.innerHTML = instructions;
      }
    });
    if (done && !document.getElementById('mwk-accept-design')) {
      const button = document.createElement('button');
      button.id = 'mwk-accept-design';
      button.type = 'button';
      button.className = 'fpd-btn mwk-accept-design';
      button.textContent = acceptLabel;
      button.addEventListener('click', acceptDesign);
      done.before(button);
    }
    if (accepted) panel();
    document.querySelectorAll('a.fpd-edit-button').forEach(link => {
      if (!link.href || !new URL(link.href).searchParams.has('li-key')) return;
      const row = link.closest('.cart-item');
      if (!row) return;
      if (link.textContent !== 'Design bearbeiten') link.textContent = 'Design bearbeiten';
      const url = new URL(link.href);
      const quantity = Number(row.querySelector('input[name="updates[]"]')?.value);
      if (Number.isSafeInteger(quantity) && quantity > 0) {
        url.searchParams.set('mwk-quantity', String(quantity));
        link.href = url.href;
      }
      url.searchParams.set('mwk-edit-options', '1');
      url.searchParams.set('mwk-cart-editor','1');
      let sizeLink = row.querySelector('.mwk-edit-options');
      if (!sizeLink) {
        sizeLink = document.createElement('a');
        sizeLink.className = 'mwk-edit-options';
        sizeLink.textContent = 'Größe & Ausführung ändern';
        link.after(sizeLink);
      }
      sizeLink.href = url.href;
    });
    if (editOptions && !autoOpened && isOpen() && designer()?.productCreated) {
      autoOpened = true;
      acceptDesign();
    }
  }

  // Take a complete snapshot only when the customer changes product options.
  // A new design/template selected inside FPD must never be overwritten.
  document.addEventListener('change', event => {
    if (!accepted || !event.target.closest(pickerSelector)) return;
    const fpd = designer();
    if (!fpd?.productCreated) return;
    pendingVariant = { instance: fpd, product: copy(fpd.getProduct()), until: Date.now() + 15000 };
    status('Größe und Ausführung werden aktualisiert …');
  }, true);

  document.addEventListener('mwk:assistant-options', () => {
    if (document.getElementById('mwk-assistant-config')) accepted = true;
  });

  function watchVariant() {
    const pending = pendingVariant;
    if (!pending) return;
    const current = designer();
    if (Date.now() > pending.until) {
      pendingVariant = null;
      status('Bitte öffne „Design weiter bearbeiten“ und prüfe deine Gestaltung vor dem Hinzufügen.');
      return;
    }
    if (!current?.productCreated) return;
    if (current !== pending.instance) {
      pendingVariant = null;
      current.addEventListener('productCreate', () => {
        status('Größe und Ausführung sind aktualisiert. Deine Gestaltung wurde übernommen.');
        document.dispatchEvent(new CustomEvent('mwk:assistant-variant-updated'));
      }, { once: true });
      current.loadProduct(pending.product);
    }
  }

  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; addControls(); watchVariant(); });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src','srcset'] });
  document.addEventListener('fpd:url-changed', () => {
    if (!pendingVariant) return;
    setTimeout(() => {
      watchVariant();
      if (pendingVariant && designer() === pendingVariant.instance && designer()?.productCreated) {
        pendingVariant = null;
        status('Größe und Ausführung sind aktualisiert. Deine Gestaltung bleibt erhalten.');
        document.dispatchEvent(new CustomEvent('mwk:assistant-variant-updated'));
      }
    }, 1200);
  });
  addControls();
})();
